export const TruncateEthAddress = (address: string | undefined) => {
    if(address) return address.slice(0,6) + "..." + address.slice(address.length - 4, address.length);
    return "";
}